import get from 'lodash.get'

const getCurrentUser = state => get(state, 'user', {})
const getCurrentUserBrokerId = state => get(getCurrentUser(state), 'brokerId', '')

const getBrokerages = state => get(state, 'brokerages', {})
const getBrokeragesItems = state => get(getBrokerages(state), 'items', [])

export const getBrokeragesIsLoading = state => get(getBrokerages(state), 'isBusy', false)

export const getFilteredBrokerages = (state) => {
  const brokerId = getCurrentUserBrokerId(state)
  const brokerages = getBrokeragesItems(state)

  return brokerages.filter(brokerage => brokerage.brokerId !== brokerId)
}
